import { CompanyPage } from "Company/Pages";
import { CompanyCreatePage } from "Company/Pages/create";
import { CompanyDetailPage } from "Company/Pages/Detail";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { CompanyPaths } from "./Routing";

export const CompanyRoutes = [
	{
		path: CompanyPaths.Index.route,
		element: (
			<PermissionGuard permission={UserPermissions.CompanyModule.read}>
				<CompanyPage />
			</PermissionGuard>
		),
	},
	{
		path: CompanyPaths.Detail.route,
		element: (
			<PermissionGuard permission={UserPermissions.CompanyModule.view}>
				<CompanyDetailPage />
			</PermissionGuard>
		),
	},
	{
		path: CompanyPaths.Create.route,
		element: (
			<PermissionGuard permission={UserPermissions.CompanyModule.create}>
				<CompanyCreatePage />
			</PermissionGuard>
		),
	},
];
